// Redux Slice for Duplication
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";

const initialState = {
  designNames: [],
  designModal: false,
  designError: {},
};

// Async thunk to duplicate designs
export const duplicateDesigns = createAsyncThunk(
  'duplicateDesignList',
  async (designData) => {
    const { ID: clientID, state, id, ID, ...sanitizedData } = designData;

    // Determine target collection based on state
    const collectionName = state === 'AssignedRooms' ? 'Assigned Rooms' : 'Rooms';

    // Add the design to the correct subcollection
    await db
      .collection("client")
      .doc(clientID)
      .collection(collectionName)
      .add(sanitizedData);
  }
);

// Slice to manage duplication design states
const duplicationDesignReducer = createSlice({
  name: 'duplicateDesign',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(duplicateDesigns.fulfilled, (state) => {
        state.designModal = true; // Show modal on success
      })
      .addCase(duplicateDesigns.pending, (state) => {
        state.designModal = false; // Hide modal while loading
      })
      .addCase(duplicateDesigns.rejected, (state, action) => {
        state.designModal = false; // Hide modal and log error
        state.designError = action.error; // Capture the error
      });
  },
});

export default duplicationDesignReducer.reducer;
